import { ErrorMessage } from "V2.0/common/fieldset";
import DefaultEndForm from "../../Default/DefaultEndForm";
import Webhook from "./Webhook";

export default WebhookNotificationForm;

function WebhookNotificationForm(props) {
  const { formState, updateFormState, errors } = props;

  const onAddWebhook = (webhook) => {
    const updatedWebhooks = [...formState.webhookList, webhook];
    updateFormState("webhookList", updatedWebhooks);
  };

  const onUpdateWebhook = (webhook, webhookIdx) => {
    const updatedWebhooks = formState.webhookList.toSpliced(
      webhookIdx,
      1,
      webhook,
    );
    updateFormState("webhookList", updatedWebhooks);
  };

  const onRemoveWebhook = (webhookIdx) => {
    const updatedWebhooks = formState.webhookList.toSpliced(webhookIdx, 1);
    updateFormState("webhookList", updatedWebhooks);
  };

  return (
    <div className="space-y-8">
      <DefaultEndForm
        formState={formState}
        updateFormState={updateFormState}
        errors={errors}
      />

      <div>
        <Webhook
          webhooks={formState.webhookList}
          onWebhookAdd={onAddWebhook}
          onWebhookRemove={onRemoveWebhook}
          onWebhookUpdate={onUpdateWebhook}
        />
        {errors.webhookList && (
          <ErrorMessage>{errors.webhookList}</ErrorMessage>
        )}
      </div>
    </div>
  );
}
